module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7HNuW"))).then(() => module.bundle.root('1iHdE'));